<template>
  <div class="page-container" dir="rtl">
    
    <!-- 1. لوحة التحكم (تختفي عند الطباعة) -->
    <div class="control-panel d-print-none text-white">
      <div class="container py-3">
        <h4 class="mb-3"><i class="fas fa-cog"></i> إعدادات طباعة الأغلفة (المرآة)</h4>
        <div class="row g-3 align-items-end">
          
          <div class="col-md-4">
            <label class="fw-bold">اسم المادة</label>
            <input v-model="subject" type="text" class="form-control text-center fw-bold" placeholder="مثال: اللغة العربية">
          </div>

          <div class="col-md-3">
            <label class="fw-bold">من مجموعة رقم</label>
            <input v-model.number="fromGroup" type="number" class="form-control text-center fw-bold">
          </div>

          <div class="col-md-3">
            <label class="fw-bold">إلى مجموعة رقم</label>
            <input v-model.number="toGroup" type="number" class="form-control text-center fw-bold">
          </div>

          <div class="col-md-2">
            <button @click="printReport" class="btn btn-warning w-100 fw-bold text-dark">
              <i class="fas fa-print ms-2"></i> طباعة
            </button>
          </div>
          
          <div class="col-12 text-center mt-2">
             <small>سيتم طباعة عدد ( {{ groupsCount }} ) غلاف/مجموعة</small>
          </div>
        </div>
      </div>
    </div>

    <!-- 2. منطقة الطباعة (الحلقة التكرارية هنا) -->
    <div id="printMe">
      
      <!-- 
           v-for: تكرار الورقة لكل رقم مجموعة في النطاق المحدد
           page-break: يفصل كل ورقة عن التي تليها
      -->
      <div 
        v-for="groupNum in generatedGroups" 
        :key="groupNum" 
        class="print-sheet-wrapper"
      >
        
        <div class="print-sheet">
          
          <!-- أ. جدول الترويسة -->
          <table class="header-table" cellpadding="0" cellspacing="0">
            <tr><td colspan="10" style="height: 20px;"></td></tr>
            <tr>
              <td style="width: 10%"></td>
              <td colspan="8" class="text-center align-middle" style="height: 150px;">
                <div class="subject-title">{{ subject }}</div>
                <!-- هنا يظهر رقم المجموعة المتغير -->
                <div class="group-title">المجموعة [ {{ groupNum }} ]</div>
              </td>
              <td style="width: 10%"></td>
            </tr>
            <tr><td colspan="10" style="height: 20px;"></td></tr>
          </table>

          <!-- ب. جدول التفريغ -->
          <table class="grid-table" cellpadding="0" cellspacing="0">
            <!-- 20 صف فارغ -->
            <tr v-for="n in 20" :key="n" style="height: 42px;">
              <td v-for="col in 10" :key="col" class="grid-cell"></td>
            </tr>

            <!-- صف العناوين -->
            <tr class="stats-header-row">
              <td class="thick-border"></td>
              <td class="thick-border"></td>
              <td class="thick-border"></td>
              <td class="thick-border"></td>
              <td colspan="2" class="thick-border text-center stats-label">جملة الحضور</td>
              <td class="thick-border text-center stats-label">غياب</td>
              <td class="thick-border text-center stats-label">خاصة</td>
              <td class="thick-border text-center stats-label">لغات</td>
              <td class="thick-border text-center stats-label">دمج</td>
            </tr>

            <!-- صف التفريغ الأخير -->
            <tr style="height: 50px;">
              <td class="thick-border"></td>
              <td class="thick-border"></td>
              <td class="thick-border"></td>
              <td class="thick-border"></td>
              <td colspan="2" class="thick-border"></td>
              <td class="thick-border"></td>
              <td class="thick-border"></td>
              <td class="thick-border"></td>
              <td class="thick-border"></td>
            </tr>
          </table>

        </div>

        <!-- فاصل صفحات إجباري بعد كل ورقة -->
        <div class="page-break"></div>

      </div> 
      <!-- نهاية الحلقة -->

    </div>

  </div>
</template>

<script>
export default {
  name: "GroupMirrorSheet",
  data() {
    return {
      subject: 'اللغة العربية',
      fromGroup: 1, // بداية الترقيم
      toGroup: 10   // نهاية الترقيم
    };
  },
  computed: {
    // توليد مصفوفة الأرقام بناء على البداية والنهاية
    generatedGroups() {
      const start = parseInt(this.fromGroup);
      const end = parseInt(this.toGroup);
      const arr = [];
      if (!isNaN(start) && !isNaN(end) && end >= start) {
        for (let i = start; i <= end; i++) {
          arr.push(i);
        }
      }
      return arr;
    },
    groupsCount() {
      return this.generatedGroups.length;
    }
  },
  methods: {
    printReport() {
    printJS({
      printable: 'printMe', // الـ ID الخاص بالعنصر
      type: 'html',


      css: [
        '/assets/css/sty_group_print.css',
        '/css/adminlte.rtl.css',
        // 'https://cdn.jsdelivr.net/npm/bootstrap@5.1.3/dist/css/bootstrap.min.css'
        ], // ملف الستايل الخاص بالتقرير فقط
      scanStyles: false, // هذا يمنع وراثة ستايل الموقع (الميزة التي طلبتها)
      style: `
    @page { size: auto; margin: 10mm; } 
    body { direction: rtl !important;  } 
    .report-table { direction: rtl !important; }`,
      documentTitle: 'شهادة الطالب' // اسم الملف عند الحفظ
    });
  },
  },

};
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Cairo:wght@400;700;900&display=swap');

.page-container {
  font-family: 'Cairo', Arial, sans-serif;
  background-color: #f0f0f0;
  min-height: 100vh;
}

.control-panel {
  background-color: #343a40;
  margin-bottom: 20px;
  box-shadow: 0 4px 6px rgba(0,0,0,0.1);
}

/* === تنسيقات الورقة === */
.print-sheet {
  background-color: white;
  width: 210mm; 
  min-height: 297mm; 
  margin: 0 auto 30px auto; /* margin bottom للفصل في العرض */
  padding: 10mm 5mm;
  box-shadow: 0 0 10px rgba(0,0,0,0.1);
  box-sizing: border-box;
}

/* الجداول */
table {
  width: 100%;
  border-collapse: collapse;
  table-layout: fixed;
}

/* النصوص */
.subject-title {
  font-family: 'Cairo', sans-serif;
  font-size: 60px;
  font-weight: 900;
  color: #000;
  line-height: 1.2;
}

.group-title {
  font-family: 'Cairo', sans-serif;
  font-size: 40px;
  font-weight: 900;
  color: #000;
  margin-top: 10px;
}

/* الحدود والخلايا */
.grid-cell {
  border: 1px solid #000000;
  height: 42px;
}

.thick-border {
  border: 3px solid #000000 !important;
}

.stats-label {
  font-size: 19px;
  font-weight: 900;
  vertical-align: middle;
}

/* === إعدادات الطباعة === */
@media print {
  @page {
    size: A4 portrait;
    margin: 0;
  }

  body {
    background-color: white;
    margin: 0;
  }

  .page-container {
    background-color: white;
  }

  .d-print-none {
    display: none !important;
  }

  .print-sheet-wrapper {
    /* هذا الكلاس يضمن أن كل div يمثل صفحة طباعة مستقلة */
    break-after: page;
    page-break-after: always;
  }

  .print-sheet {
    box-shadow: none;
    margin: 0;
    width: 100%;
    height: auto;
  }
}
</style>